import Vue from 'vue'
import Cart from 'lib/cart'
import state from 'lib/appState'

export default el => {
  return new Vue({
    el,
    data () {
      return {
        state
      }
    },
    computed: {
      getSuggestedAddOns () {
        if (this.state.activeProduct) {
          return this.state.activeProduct.suggestedAddOns
        }
        return []
      },
      title () {
        if (this.getSuggestedAddOns) {
          return this.getSuggestedAddOns.title
        }
      },
      products () {
        if (this.getSuggestedAddOns) {
          return this.getSuggestedAddOns.products
        }
        return []
      }
    },
    methods: {
      async addToCart (id) {
        try {
          this.loading = true
          let payload = [{
            id: id,
            quantity: 1
          }]
          await Cart.add(payload)
          // window.location = '/cart'
          window.MicroBus.emit(`side-cart:toggle`)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      }
    }
  })
}
